<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wmlxtb/tc-custom/9781683501565.jpg?1700807480722" alt="This image is the cover for the book Taming Chaos Workbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taming Chaos Workbook
      </h1>
      <p class="bookDescription body article font2">
        <p>Teens make mistakes. Sometimes fatal ones.</p><p></p><p>In today’s world, parents and educators are often baffled about how to impart values and discuss the virtues of conscientiousness, rational thinking, and empathy into wired, stressed, and over-stimulated teens! Through an engaging and relatable story, "Taming CHAOS" teaches a step-by-step process for making good decisions. </p><p></p><p>"Taming CHAOS" encourages a healthy conversation with teenagers on the process of “decision-making,” acknowledging that the decisions and choices they face are valid and worthy of careful consideration.</p><p></p><p>Whether you are a teacher or study group discussion leader, "Taming CHAOS" offers a unique process of “decision making” to teenagers and young adults. To remain grounded as a teenager requires a level of clarity and iron restraint that most teenagers simply don't have; thus, many times not always making good decisions or choices in their individual best interest.</p><p></p><p>This Leader’s Discussion Guide &amp; Workbook, is an excellent resource and compliment for any teacher or study group discussion leader instructing teenagers on the decision making process. The Workbook is well organized and formatted for each chapter of "Taming Chaos," providing a short summary, concepts section, and discussion questions which encourage students to drill down on the chapter concepts, employing a mix of concrete &amp; abstract questions.</p><p></p><p>We get it. Teachers already have to juggle so many balls in the air. That’s why we created simple, succinct and well-written lesson plans for each chapter. These lesson plans will provide a “ready-made” solution for teaching and growing a student’s understanding of decision making.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary R. Miller
      </h2>
      
      <p class="authorDescription body article">Gary is the founder and Managing Partner of The Miller Financial Group, a 2nd generation business practice owner, of an Independent Property & Casualty Insurance, Financial Services & Risk Management Based Consulting Practice, established in the historic Ft. Washington and Spring House, PA areas, operating 68+ years, providing first class professional insurance solutions, sound financial planning & strong risk management based advice & counsel to its clientele.  Gary started his career in insurance over 35 years ago, joining his father’s long standing and successful insurance practice which was founded in 1948, and has continued to serve many households and businesses of Montgomery County.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ed5f7e6